import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Briefcase, Users, Activity, Award, Plus, Eye } from 'react-feather';
import config from '../../../../config';
import CustomizerContext from '../../../../_helper/Customizer';
import '../../sadmin.css';

const greetingFor = (date = new Date()) => {
    const h = date.getHours();
    if (h < 12) return 'Good morning';
    if (h < 18) return 'Good afternoon';
    return 'Good evening';
};

const DashboardSAdmin = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { layoutURL } = useContext(CustomizerContext);
    const layout = layoutURL || 'default';

    const token = localStorage.getItem('sessiontoken');
    const configheader = { headers: { Authorization: `${token}` } };
    const loginName = localStorage.getItem('loginName') || t('Super Admin');

    const [stats, setStats] = useState({
        totalConcessionaire: null,
        activeConcessionaire: null,
        totalTenants: null,
        liveTenants: null,
    });

    useEffect(() => {
        axios
            .get(`${config.hostname}/sadmindashboard/getdetails`, configheader)
            .then((response) => {
                setStats({
                    totalConcessionaire: response.data.totalConcessionaireCount,
                    activeConcessionaire: response.data.activeConcessionaireCount,
                    totalTenants: response.data.totalTenantsCount,
                    liveTenants: response.data.liveTenantsCount,
                });
            })
            .catch((err) => console.error(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fmt = (v) => (v === null || v === undefined || v === '' ? '—' : String(v));

    const kpis = [
        { title: t('Total Concessionaires'), value: fmt(stats.totalConcessionaire), tone: 'accent', icon: <Briefcase size={16} /> },
        { title: t('Active Concessionaires'), value: fmt(stats.activeConcessionaire), tone: 'amber', icon: <Activity size={16} /> },
        { title: t('Total Tenants'), value: fmt(stats.totalTenants), tone: 'purple', icon: <Users size={16} /> },
        { title: t('Live Tenants'), value: fmt(stats.liveTenants), tone: 'green', icon: <Award size={16} /> },
    ];

    return (
        <div className="v3 v3-sadmin">
            <header className="v3-sadmin-hero">
                <div className="v3-sadmin-hero-text">
                    <div className="v3-label">{t('Control plane · Super admin')}</div>
                    <h1 className="v3-display v3-sadmin-greeting">
                        {t(greetingFor())},{' '}
                        <span className="v3-sadmin-name">{loginName}</span>
                    </h1>
                    <p className="v3-body v3-sadmin-sub">
                        {t('Platform-wide overview. Drill into concessionaires and admin tools from the sidebar.')}
                    </p>
                </div>
                <div className="v3-sadmin-hero-actions">
                    <button
                        type="button"
                        className="v3-btn v3-btn-ghost"
                        onClick={() => navigate(`${process.env.PUBLIC_URL}/controlpanel/concessionaire/viewconcessionaire/${layout}`)}
                    >
                        <Eye size={14} />
                        {t('View concessionaires')}
                    </button>
                    <button
                        type="button"
                        className="v3-btn v3-btn-primary"
                        onClick={() => navigate(`${process.env.PUBLIC_URL}/controlpanel/concessionaire/addnewconcessionaire/${layout}`)}
                    >
                        <Plus size={14} />
                        {t('New concessionaire')}
                    </button>
                </div>
            </header>

            <section className="v3-sadmin-kpis">
                {kpis.map((k) => (
                    <div key={k.title} className="v3-card v3-sadmin-kpi">
                        <div className="v3-sadmin-kpi-top">
                            <span className="v3-label">{k.title}</span>
                            <div className={`v3-sadmin-kpi-icon ${k.tone}`}>{k.icon}</div>
                        </div>
                        <span className="v3-sadmin-kpi-value">{k.value}</span>
                    </div>
                ))}
            </section>
        </div>
    );
};

export default DashboardSAdmin;
